import './App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import Home from './Pages/Home';
import Services from './Pages/Services';
import NetworkInfrastructure from './Pages/NetworkInfrastructure';
import UniFiNetworking from './Pages/UniFiNetworking';
import StorageAndBackup from './Pages/StorageAndBackup';
import DomainsDnsIntegrations from './Pages/DomainsDnsIntegrations';
import Contact from './Pages/Contact';
import Error from './Pages/Error';
import Team from './Pages/Team';
function App() {

  return (
    <Router>
      <div className="App">
        <Switch>
          <Route exact path="/services/network-infrastructure">
            <NetworkInfrastructure />
          </Route>
          <Route exact path="/products/unifi-networking">
            <UniFiNetworking />
          </Route>
          <Route exact path="/products/unifi-network-installation">
            <UniFiNetworking />
          </Route>
          <Route exact path="/services/storage-and-backup">
            <StorageAndBackup />
          </Route>
          <Route exact path="/services/domains-dns-integrations">
            <DomainsDnsIntegrations />
          </Route>
          <Route exact path="/services">
            <Services />
          </Route>
          <Route path="/contact">
            <Contact />
          </Route>
          <Route path="/team">
            <Team />
          </Route>
          <Route path="/pay" component={() => {
            window.location.replace("https://buy.stripe.com/9AQ7sWclO9jg4o0eUU");
            return null;
          }}/>
          <Route exact path="/">
            <Home />
          </Route>
          <Route path="*" component={() => {
            if (process.env.NODE_ENV === 'development') {
              window.location.replace("https://solaceintegrations.com/error");
            } else {
              window.location.replace("/error");
            }
            return null;
          }}/>
        </Switch>
      </div>
    </Router>
  );
}

function About() {
  return <h2>About</h2>;
}

function Users() {
  return <h2>Users</h2>;
}

export default App;
